@if (devToolsCardService.isEnabled() && devToolsCardService.hasProviders()) {
  @let opened = devToolsCardService.isCardOpened();

  <button
    type="button"
    class="border-theme-gray-500 text-theme-gray-700 hover:bg-theme-blue-gray fixed top-1/2 right-0 z-1000 flex h-14 w-9 -translate-y-1/2 items-center justify-center rounded-l-md border border-r-0 bg-white shadow-sm"
    data-testid="dev-tools-card-trigger"
    [attr.aria-expanded]="opened"
    aria-label="Dev-Tools"
    (click)="devToolsCardService.toggleCard()">
    <svg
      class="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="chevron()" />
    </svg>
  </button>

  <aside
    class="border-theme-gray-500 fixed top-1/2 right-11 z-1000 flex max-h-[70vh] w-88 -translate-y-1/2 flex-col rounded-xl border bg-white shadow-xl transition duration-300 ease-out motion-reduce:transition-none"
    data-testid="dev-tools-card"
    [class.translate-x-8]="!opened"
    [class.opacity-0]="!opened"
    [class.pointer-events-none]="!opened"
    [attr.inert]="inert()"
    aria-label="Dev-Tools">
    <div class="border-b-primary flex items-center justify-between border-b-2 p-4">
      <div class="flex flex-col">
        <span class="text-lg font-bold">Dev-Tools</span>
        <span class="text-theme-gray-700 text-xs">nur außerhalb von PROD</span>
      </div>
      <button
        type="button"
        class="text-theme-gray-700 hover:bg-theme-blue-gray rounded p-1 hover:text-black"
        data-testid="dev-tools-card-close"
        aria-label="Schließen"
        (click)="devToolsCardService.closeCard()">
        <svg
          class="h-5 w-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="flex flex-col gap-4 overflow-y-auto p-4">
      @for (panel of panels(); track panel.provider.id) {
        <section
          class="border-theme-gray-500 flex flex-col gap-3 border-t pt-4 first:border-t-0 first:pt-0">
          <h2 class="text-theme-gray-800 text-xs font-bold tracking-wide uppercase">
            {{ panel.provider.label }}
          </h2>
          <ng-container *ngComponentOutlet="panel.provider.panel; inputs: panel.inputs" />
        </section>
      }
    </div>
  </aside>
}
